import { ReactNode } from "react";
import FlashMessages from "@/components/FlashMessages";
import { Toaster } from "@/components/ui/sonner";

interface GuestLayoutProps {
  children: ReactNode;
}

export default function GuestLayout({ children }: GuestLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted flex items-center justify-center p-4">
      <Toaster />
      <FlashMessages />
      <div className="w-full max-w-md">{children}</div>
    </div>
  );
}
